import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, Type } from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { AvatarModule } from '../../atoms/avatar/avatar.module';
import { BodyKnowledgeDetailModule } from '../../molecules/body-knowledge-detail/body-knowledge-detail.module';
import { ButtonModule } from '../../atoms/button/button.module';
import { CategoriesAnchorModule } from '../../molecules/categories-anchor/categories-anchor.module';
import { CommonModule } from '@angular/common';
import { CreateQuotationModalComponent } from './create-quotation-modal.component';
import { CreateTagModule } from './../../molecules/create-tag/create-tag.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderCardModule } from '../header-card/header-card.module';
import { KnowledgeAttachmentViewModule } from '../../molecules/knowledge-attachment-view/knowledge-attachment-view.module';
import { KnowledgeBodyTitleModule } from '../../molecules/knowledge-body-title/knowledge-body-title.module';
import { TextModule } from '../../atoms/text/text.module';
import { TextareaModule } from '../../atoms/textarea/textarea.module';
import { TimelineCardBodyModule } from '../../molecules/timeline-card-body/timeline-card-body.module';
import { TimelineCardHeaderModule } from '../../molecules/timeline-card-header/timeline-card-header.module';

const components: Type<any>[] = [CreateQuotationModalComponent];

@NgModule({
  imports: [
    CommonModule,
    HeaderCardModule,
    ButtonModule,
    TimelineCardHeaderModule,
    TimelineCardBodyModule,
    CategoriesAnchorModule,
    TextModule,
    TextareaModule,
    AvatarModule,
    ReactiveFormsModule,
    FormsModule,
    //fa-icon
    FontAwesomeModule,
    AngularSvgIconModule,
    KnowledgeAttachmentViewModule,
    BodyKnowledgeDetailModule,
    KnowledgeBodyTitleModule,
    CreateTagModule
  ],
  declarations: [components],
  exports: [components],
})
export class CreateQuotationModalModule { }
